import URL from 'url-parse';
import find from 'lodash/find';
import { omit } from '../utils/commonUtils';
import { uriMappings } from './config.json';

export const isCheckoutSdk = (url) => {
  const pattern = /(?=.*(localhostcui|checkout-widget|checkoutcui|saleswidget))(?=.*sdk.min.js)(?=.*\.(active\.com|activenetwork\.com))/;
  return pattern.test(url);
};

export const getScriptHost = (src) => {
  const match = src.match(/(https?:\/\/[^/]+)/);
  return match ? match[1] : null;
};

export const getPresrcOfStaticResource = (src) => {
  return src && src.split('/sdk.min.js')[0];
};

export const getCustomizeParams = (query, blacklist) => {
  const parameters = Object.keys(omit(query, blacklist))
    .map(key => `${key}=${query[key]}`)
    .join('&');
  return parameters ? `?${parameters}` : '';
};

export const getMappingBaseUris = (scriptHost) => {
  const uriMappingData = new Map(uriMappings);
  const uriMapping = uriMappingData.get(scriptHost);
  const nextVersion = process.env.VERSION;

  if (!uriMapping) {
    return { cdn: '', api: '' };
  }

  const cdnHost = uriMapping.cdn ? `${uriMapping.cdn}/${nextVersion}` : '';
  const apiHost = uriMapping.api ? uriMapping.api : '';

  return { cdn: cdnHost, api: apiHost };
};

export const getTargetScriptInfos = () => {
  const scripts = document.getElementsByTagName('script');

  const sdkUrlScript = find(scripts, (o) => {
    return isCheckoutSdk(o.src);
  });

  if (!sdkUrlScript) return {};

  const sdkUrl = sdkUrlScript.src;

  const { query } = new URL(sdkUrl, true);
  const scriptHost = getScriptHost(sdkUrl);

  const mapppingBaseUri = getMappingBaseUris(scriptHost);
  const apiHost = mapppingBaseUri.api || scriptHost;
  const preUrlOfStaticResouce = mapppingBaseUri.cdn || getPresrcOfStaticResource(sdkUrl);

  return {
    query,
    preUrlOfStaticResouce,
    apiHost,
  };
};
